import type { MarketingCustomAudience } from "../interfaces/KYDMarketing";

/**
 * Step Functions `ProcessCustomAudiences` Map items should be flat audience rows.
 * The interests branch used to Pass through `{ context, execution_id, audience }`.
 */
export function unwrapStoredCustomAudienceRow(item: unknown): unknown {
  if (!item || typeof item !== "object") return item;
  const record = item as Record<string, unknown>;
  if (
    record.audience &&
    typeof record.audience === "object" &&
    (record.execution_id != null || record.context != null)
  ) {
    return record.audience;
  }
  return item;
}

export function normalizeStoredCustomAudiences(
  customAudiences: readonly unknown[] | undefined
): MarketingCustomAudience[] | undefined {
  if (!customAudiences?.length) return undefined;
  return customAudiences.map((item) =>
    unwrapStoredCustomAudienceRow(item)
  ) as MarketingCustomAudience[];
}
